import request from '@/utils/request'

export function listArticles() {
  return request.get('/article/list')
}

export function getArticle(articleId) {
  return request.get('/article/' + articleId)
}
